import { toggleImages } from '../../util/image_toggle_util.js';
import { updatePrefs } from '../../util/user_prefs_util.js';

export function registerEventHandlers(element) {
  element.addEventListener('change', (event) => handleToggleClick(event));
}

export function handleToggleClick(event) {
  const triggerEl = event.target.closest('[data-analytics-class="font-images-toggle"]');
  if (!triggerEl) {
    return;
  }

  updatePrefs({ hideImages: !triggerEl.checked });

  toggleImages(triggerEl.checked, event);
}
